/* eslint-disable camelcase */
export default {
	OU_subject: 'OU主体',
	founder: '创建人',
	isEnabled: '是否生效',
	Subject_category: '主体类别',
	Whether_to_upload_business_license: '是否上传营业执照',
	Whether_to_upload_legal_person_certificate: '是否上传法人证件',
	update_time: '更新时间',
	last_update_by: '最后更新人',
	actions: '操作',
	query_condition: '查询条件',
	please_input_ou_subject: '请选择或者搜索OU主体',
	please_input_creator: '请输入创建人',
	subject_status: '主体信息状态',
	please_input_subject_status: '请选择主体信息状态',
	legal_person_status: '法人信息状态',
	please_input_legal_person_status: '请选择法人信息状态',
	query_result: '查询结果',
	subject_maintain: '主体信息维护',
	legal_person_maintain: '法代信息维护',
	submit_work: '提交并生效',
	ou_exist_tip: '该主体信息已经录入，请选择其他主体',
	cannot_find_ou_subject_info: '找不到该主体资质信息',
	subject_basic_info: '主体基本信息',
	ou_code: 'OU编号',
	please_input_ou_code: '请输入OU编号',
	ou_subject_all: 'OU主体(全称)',
	please_select_subject_category: '请选择主体类别',
	company_name: '公司名称',
	please_input_company_name: '请输入公司名称',
	reg_country: '注册国家/地区',
	please_select_reg_country: '请选择注册国家/地区',
	reg_address: '注册地址',
	please_input_reg_address: '请输入注册地址',
	obtained_uscc: '是否三证合一',
	please_select_obtained_uscc: '请选择是否三证合一',
	is_finance_institution: '是否是金融机构',
	please_select_is_finance_institution: '请选择是否是金融机构',
	finance_type: '金融机构类型',
	please_select_finance_type: '请选择金融机构类型',
	biz_scope: '经营范围',
	please_input_biz_scope: '请输入经营范围',
	subject_detail_info: '主体资质详细信息',
	new_certificate: '新增证件',
	qua_doc_type: '资质文件类型',
	please_select_qua_doc_type: '请选择资质文件类型',
	union_code: '统一社会信用代码',
	please_input_union_code: '请输入统一社会信用代码',
	qualification_attachments: '资质附件',
	please_select_date: '请选择日期',
	cert_num: '证件编码',
	delete_cert: '删除证件',
	subject_bank_info: '主体银行信息',
	account_name: '开户名称',
	please_input_account_name: '请输入开户名称',
	account_type: '账户类型',
	please_select_account_type: '请选择账户类型',
	account_num: '银行账号',
	please_input_account_num: '请输入银行账号',
	bank_belone_country: '开户银行所在国别',
	please_select_bank_country: '请选择开户银行所在国别',
	bank_province: '开户省份',
	please_select_province: '请选择开户省份',
	bank_city: '开户城市',
	please_select_bank_city: '请选择开户城市',
	bank: '开户银行',
	please_select_bank: '请选择开户银行',
	branch_bank_name: '开户银行全称（含支行）',
	branch_bank_name_tip_1: '需填写银行全称，如"深圳农村商业银行XXX支行"，详细参见',
	branch_bank_name_tip_2: '开户银行全称（含支行）对照表',
	please_input_bank_full_name: '请输入开户银行全称',
	cnaps_code: '联行号',
	bank_branch_id: '联行号',
	please_input_cnaps_code: '请输入联行号',
	cnaps_code_or_branch_bank: '开户银行全称和联行号二选一填写',
	id_holder_type: '人员类型',
	plz_id_holder_type: '请选择人员类型',
	is_owner: '是否受益人',
	plz_is_owner: '请选择是否为受益人',
	id_doc_type: '证件类别',
	plz_id_doc_type: '请选择证件类型',
	person_name: '人员名称',
	plz_person_name: '请输入人员名称',
	cert_name: '证件名称',
	plz_cert_name: '请输入证件名称',
	cert_number: '证件号码',
	plz_cert_number: '请选择证件号码',
	front_view_pic: '正面照上传',
	upload_front_view: '上传正面',
	plz_upload_front_view: '请上传正面',
	back_view_pic: '反面照上传',
	upload_back_view: '上传反面',
	plz_upload_back_view: '请上传反面',
	cert_address: '证件地址',
	plz_cert_address: '请输入证件地址',
	legal_person_info: '人员信息',
	authorize_letter: '法定代表人说明函',
	bank_address_code: '省市区编码'
};
